<template>
  <div id="marquee-container" class="px-5">

    <marquee-text :duration="speed" :paused="pause_me" @mouseover="pause_me = true" @mouseleave="pause_me = false">
        <marquee-content></marquee-content>
    </marquee-text>
    
  </div>
</template>

<script>

import MarqueeText from 'vue-marquee-text-component'
import MarqueeContent from '../components/MarqueeContent.vue';
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Marquee",
  props: [],
  components: {MarqueeText, MarqueeContent},
  data: () => ({
    speed: 0,
    pause_me: false,
  }),
  computed: {
    ...mapGetters([
      'messageLength',
    ]),
    pause() {
      return this.pause_me ? 'paused' : '';
    },
  },
  methods: {
    ...mapActions([]),
    pauseit() {
      this.pause_me = true;
    },
    setSpeed(n) {
      this.speed = n /25;
    }
  },
  created() {
    if (this.messageLength > 0) {
      this.setSpeed(this.messageLength);
    }
  },
  watch: {
    messageLength(n, o) {
      this.setSpeed(n)
    }
  }
};
</script>

<style scoped>

    #marquee-container {
        border: 2px solid var(--v-secondary-base);
        /* background-color: var(--v-primary-base); */
        background-color: #191970;
        color: white;
        /* border-radius: 10px; */
    }

    .reddo {
        color: red;
    }

</style>
